import { render, staticRenderFns } from "./EditSubAccount.component.vue?vue&type=template&id=2f8cf94a&"
import script from "./EditSubAccount.component.vue?vue&type=script&lang=ts&"
export * from "./EditSubAccount.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports